var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSleep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26953 6.5V0.5H15.731C16.6935 0.5 17.5174 0.84275 18.2028 1.52825C18.8883 2.21358 19.231 3.0375 19.231 4V6.5H7.26953ZM0.769531 9.3845V7.8845H19.231V9.3845H0.769531ZM3.32728 6.5C2.60928 6.5 2.00353 6.25317 1.51003 5.7595C1.01636 5.266 0.769531 4.66025 0.769531 3.94225C0.769531 3.22442 1.01636 2.61867 1.51003 2.125C2.00353 1.6315 2.60928 1.38475 3.32728 1.38475C4.04511 1.38475 4.65086 1.6315 5.14453 2.125C5.63803 2.61867 5.88478 3.22442 5.88478 3.94225C5.88478 4.66025 5.63803 5.266 5.14453 5.7595C4.65086 6.25317 4.04511 6.5 3.32728 6.5Z",
    fill: "#49A9EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleep);
export default __webpack_public_path__ + "static/media/Sleep.7e2e328beb81a02b5b780ded8e86a0b6.svg";
export { ForwardRef as ReactComponent };